import {REST} from '../../api'
import {
    type AssignVesselToTagReq,
    type CreateVesselTagReq,
    type UnassignVesselTagReq,
    type UpdateVesselTagReq,
    type VesselTag,
    type VesselTagResponse,
} from './types/vessel-tag'
import {type GuidType} from '../../values/generic-type-definitions'

const VESSEL_TAGS_REST_URL = '/vessels/api/v1/locationTags'

// Re-export types for backward compatibility
export type {VesselTag, VesselTagResponse}

export function getAllLocationTagsByLocation() {
    return REST.get<{[k: GuidType]: VesselTagResponse[]}>(
        `${VESSEL_TAGS_REST_URL}/allLocationTagsByLocation`,
    )
}

export function getAllVesselTags() {
    return REST.get<VesselTag[]>(VESSEL_TAGS_REST_URL)
}

export function createVesselTag(req: AssignVesselToTagReq | CreateVesselTagReq) {
    return REST.post<VesselTag>(VESSEL_TAGS_REST_URL, req)
}

export function updateVesselTag(req: UpdateVesselTagReq) {
    return REST.put<VesselTag>(VESSEL_TAGS_REST_URL, req)
}

export function unassignVesselTag(req: UnassignVesselTagReq) {
    return REST.post(`${VESSEL_TAGS_REST_URL}/unassignLocationTagFromLocation`, req)
}
